import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getUserProfile = async userId => {
  const { data, error } = await supabase.from('users').select('*').eq('id', userId).single();

  if (error && error.code !== 'PGRST116') {
    // Not found error
    throw error;
  }

  if (!data) {
    // Create or update default profile
    const { data: newProfile, error: upsertError } = await supabase
      .from('users')
      .upsert({
        id: userId,
        username: 'New User',
      })
      .select()
      .single();

    if (upsertError) {
      throw upsertError;
    }

    return newProfile;
  }

  return data;
};

export const updateUserProfile = async (userId, profileData) => {
  const client = await getAuthenticatedClient();

  const { data, error } = await client
    .from('users')
    .upsert({
      id: userId,
      ...profileData,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
